module.exports = __webpack_public_path__ + "img/LogoPROASA_Color.225dab4e.png";